import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordTeamDataClass } from './Pisa/pisaTimerecordTeamDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordTeam = pisaTimerecordTeamDataClass(attributes)
